import React, { FunctionComponent } from 'react';

interface IButtonDefault {
  text: string,
  type?: 'submit' | 'reset' | 'button' | undefined,
  imgClass?: string,
  disabledClass?: string
  loadClass?: string
  colorClass?: string
  addClass: string
  tabIndex?: number
  thisFunc?(): void
}


const ButtonDefault: FunctionComponent<IButtonDefault> = (props) => {
  const { text, type, imgClass, disabledClass, loadClass, thisFunc, colorClass, addClass, tabIndex } = props;
  const defaultCass = 'button';
  return (
    <button onClick={thisFunc} className={
      defaultCass + ' ' +
      (addClass ? addClass + ' ' : '') +
      (imgClass ? imgClass + ' ' : '') +
      (disabledClass ? disabledClass + ' ' : '') +
      (loadClass ? loadClass + ' ' : '') +
      (colorClass ? colorClass + ' ' : '')
    }
            type={type}
            tabIndex={tabIndex}
    >
      <span>{text}</span>
    </button>
  );
};

export default ButtonDefault;
